import { combineEpics } from "redux-observable";
import {
  fetchItemsEpic,
  fetchNextPageEpic,
  setFilterForSearchEpic,
  resetPageForItemsEpic,
  fetchItemByIdEpic,
  removeItemByIdEpic,
  removeTagFromItemEpic
} from "./items";

import {
  loginEpic,
  loginWithTokenEpic,
  logoutEpic,
  recoverPasswordEpic,
  redirectAfterLoginEpic,
  redirectAfterLogoutEpic
} from "./auth";

import {
  getMainFiltersEpic,
  filtersByTypologiesChangeEpic,
  getFiltersByTypologiesEpic
} from "./filters";
import {
  getLanguagesEpic,
  setBrowserLanguageEpic,
  setLanguageEpic
} from "./language";

export const rootEpic = combineEpics(
  getLanguagesEpic,
  setBrowserLanguageEpic,
  setLanguageEpic,
  loginEpic,
  loginWithTokenEpic,
  logoutEpic,
  recoverPasswordEpic,
  redirectAfterLoginEpic,
  getMainFiltersEpic,
  filtersByTypologiesChangeEpic,
  getFiltersByTypologiesEpic,
  fetchItemsEpic,
  fetchNextPageEpic,
  setFilterForSearchEpic,
  redirectAfterLogoutEpic,
  resetPageForItemsEpic,
  fetchItemByIdEpic,
  removeItemByIdEpic,
  removeTagFromItemEpic
);



// WEBPACK FOOTER //
// ./src/epics/index.js